/* AT2 EXPERIMENT - Gradient Background Component */

/**
 * Composant réutilisable pour créer un arrière-plan avec gradient radial + bruit
 *
 * Palette:
 * - Dark green (coins)
 * - Pastel light pink (côtés)
 * - Pastel light yellow (centre)
 * - Texture de bruit SVG en overlay
 */

import { Box } from '@evaneos/b2b-ui';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
};

/**
 * Wrapper avec gradient radial multi-points et effet de bruit SVG
 */
export function GradientBackground({ children }: Props) {
    return (
        <Box
            sx={{
                background: `
                    radial-gradient(circle at 100% 60%, rgb(125 196 114) -40%, transparent 60%), 
                    radial-gradient(circle at 5% 0%, #0d6b50 5%, transparent 90%), 
                    radial-gradient(circle at 0% 130%, rgb(255 148 229) 25%, transparent 80%)
                `,
                backgroundSize: '400% 400%',
                animation: 'gradient 10s ease infinite',
                position: 'relative',
                overflow: 'hidden',

                '@keyframes gradient': {
                    '0%': {
                        backgroundPosition: '55% 45%',
                    },
                    '50%': {
                        backgroundPosition: '45% 55%',
                    },
                    '100%': {
                        backgroundPosition: '55% 45%',
                    },
                },
            }}
        >
            {/* SVG Noise overlay positionné au-dessus */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    opacity: 0.3,
                }}
            >
                <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                    <filter id="noiseFilter">
                        <feTurbulence
                            type="fractalNoise"
                            baseFrequency="0.6"
                            numOctaves="1"
                            stitchTiles="stitch"
                        />
                    </filter>
                    <rect width="100%" height="100%" filter="url(#noiseFilter)" />
                </svg>
            </Box>
            {/* Contenu au-dessus du noise */}
            <Box sx={{ position: 'relative', zIndex: 3 }}>{children}</Box>
        </Box>
    );
}
